<div
  *ngIf="showGroupMenu"
  class="member-block sidenav-item-child selected group-level"
>
  <div
    *ngIf="groupNameLoader; else showSidenavHeading"
    class="flex flex-row w-full justify-center items-center"
  >
    <mat-progress-spinner
      [diameter]="30"
      class="sidenav-header-loader"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
  <ng-template #showSidenavHeading>
    <div>
      <div
        class="heading w-[15rem] group-name font-poppins font-semibold">
        {{ groupName }}
      </div>
      <div class="sub-heading font-work-sans font-normal">
        Started On - {{ groupStartedOn }}
      </div>
    </div>
    <app-icon
      (click)="commonService.closeDrillDown()"
      class="close-drilldown-level"
      icon="close"
    ></app-icon>
  </ng-template>
</div>
<div
  *ngIf="showMemberMenu"
  [class.adult-level]="memberRole === roles.adult"
  [class.participant-level]="memberRole === roles.participant"
  class="member-block sidenav-item-child selected"
>
  <div
    *ngIf="memberNameLoader; else showSidenavHeading"
    class="flex flex-row w-full justify-center items-center"
  >
    <mat-progress-spinner
      [diameter]="30"
      class="sidenav-header-loader"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
  <ng-template #showSidenavHeading>
    <div>
      <div class="heading font-poppins font-semibold">
        {{ memberName }}
      </div>
      <div class="sub-heading font-work-sans font-normal">
        {{ memberAge }} Years - {{ memberGender }}
      </div>
    </div>
    <app-icon
      (click)="commonService.closeDrillDown()"
      class="close-drilldown-level"
      icon="close"
    ></app-icon>
  </ng-template>
</div>
<div
  *ngIf="showCoachMenu || showClientAdminMenu"
  [class.client-admin-level]="memberRole === roles.clientAdmin"
  [class.coach-level]="memberRole === roles.coach"
  class="member-block sidenav-item-child selected"
>
  <div
    *ngIf="memberNameLoader; else showSidenavHeading"
    class="flex flex-row w-full justify-center items-center"
  >
    <mat-progress-spinner
      [diameter]="30"
      class="sidenav-header-loader"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
  <ng-template #showSidenavHeading>
    <div class="heading font-poppins font-semibold">
      {{ memberName }}
    </div>
    <app-icon
      (click)="commonService.closeDrillDown()"
      class="close-drilldown-level"
      icon="close"
    ></app-icon>
  </ng-template>

</div>
<div
  *ngIf="showClientMenu"
  class="member-block sidenav-item-child selected org-level"
>
  <div
    *ngIf="clientNameLoader; else showSidenavHeading"
    class="flex flex-row w-full justify-center items-center"
  >
    <mat-progress-spinner
      [diameter]="30"
      class="sidenav-header-loader"
      mode="indeterminate"
      strokeWidth="5"
    />
  </div>
  <ng-template #showSidenavHeading>
    <div class="heading font-poppins font-semibold">
      {{ clientName }}
    </div>
    <app-icon
      (click)="commonService.closeDrillDown()"
      class="close-drilldown-level"
      icon="close"
    ></app-icon>
  </ng-template>
</div>
<div
  *ngFor="let eachConfig of config"
  [class.is-drilldown]="showCoachMenu || showGroupMenu || showMemberMenu || showClientAdminMenu || showClientMenu"
>
  <div
    (click)="navigate(eachConfig)"
    *ngIf="!eachConfig['isExpandable']; else expandableSidenavItem"

    [class.selected]="eachConfig['isSelected']"
    class="sidenav-item font-poppins font-semibold"
  >
    <span class="sidenav-item-label">{{ eachConfig.label }}</span>
    <app-pending-survey-badge
      *ngIf="eachConfig.key === 'my-questionnaires'"
      [isSelected]="eachConfig['isSelected']"
    ></app-pending-survey-badge>
  </div>
  <ng-template #expandableSidenavItem>
    <div
      class="parent-sidenav-item font-poppins font-semibold"
    >
      <div
        (click)="navigate(eachConfig)"
        [class.selected]="eachConfig['isSelected']"
        class="sidenav-item expandable"
      >
        <div>
          {{ eachConfig.label }}
        </div>
        <div>
          <app-icon
            [icon]="eachConfig['isExpanded'] ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
          ></app-icon>
        </div>
      </div>
      <div
        [class.hidden]="sideNavWeeksListData?.loading && isFirstPage"
      >
        <div
          (scrolled)="onScroll()"
          *ngIf="eachConfig['isExpanded']"
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="10"
          [scrollWindow]="false"
          class="children-section"
          id="scroll"
          infiniteScroll
        >
          <div
            (click)="selectChildNavigation(eachConfig, i)"
            *ngFor="let eachChild of eachConfig.children; let i = index"
            class="sidenav-item-child-wrapper font-poppins font-semibold"
          >
            <div
              [class.selected]="eachChild['isSelected']"
              class="sidenav-item-child"
            >
              <div class="heading font-poppins font-semibold">
                {{ eachChild['heading'] }}
              </div>
              <div class="sub-heading font-work-sans font-normal">
                {{ eachChild['subHeading'] }}
              </div>
            </div>
          </div>
          <div *ngIf="sideNavWeeksListData?.loading"
               [ngClass]="{ 'initial': isFirstPage }"
               class="loader flex justify-center items-center w-full">
            <mat-spinner/>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
